import React from 'react'
import { Table } from '@themesberg/react-bootstrap'
import { getPercentageColor, getTextColor } from '../../utils/dashboardEffects'
import { useNavigate } from 'react-router-dom'
const PlayerReportTable = ({ tableData, isPlayer }) => {
  const navigate = useNavigate()
  return (
    <div style={{ overflow: 'auto', maxHeight: '385px' }}>
      <Table striped responsive hover size='sm' className='text-center mt-4'>
        <thead className='thead-light'>
          <tr>
            {isPlayer
              ? ['Id', 'Name',
                'Total Bets',
                'Total Wins',
                //'Total Loss',
                'GGR',
                'GCR',
                'NGR',
              ].map((h) => (
                <th key={h}>{h}</th>
              ))
              : [
                'ID',
                'Name',
                'Total Bets',
                'Total Wins',
                //'Total Loss',
                'GGR',
                'Handle',
                'NGR',
                'Wallet balance'
              ].map((h) => (
                <th key={h}>{h}</th>
              ))}
          </tr>
        </thead>

        <tbody>
          {tableData && tableData.length > 0
            ? tableData.map(({ userName, totalAmount: totalBet, win: totalWin, loss: totalLoss, GGR, NGR, payout, GCR, userId, walletAmount, handle }, idx) => {
              return (
                <tr key={`top-loosers ${userId}`}>
                  <td style={{ textAlign: 'center' }}>
                    {userId}
                  </td>
                  <td style={{ textAlign: 'center' }} >
                    <span
                      style={{ cursor: 'pointer' }}
                      className='text-link d-inline-block text-truncate'
                      onClick={() => navigate(`/admin/users/details/${userId}`)}
                    >
                      {userName}
                    </span>
                  </td>
                  <td style={{ color: 'green' }}>$ {totalBet || '0'}</td>
                  <td style={{ color: 'red' }}>$ {totalWin || '0'}</td>
                  {/* <td style={{ color: 'red' }}>$ {totalLoss || '0'}</td> */}
                  <td className={`${getTextColor(GGR)}`}>$ {GGR || '0'}</td>
                  {/* <td className={`${getTextColor(GCR)}`}>$ {GCR || '0'}</td> */}
                  <td>$ {handle || '0'}</td>
                  <td className={getPercentageColor(NGR)}>${NGR || '0'}</td>
                  <td>$ {walletAmount || '0'}</td>
                </tr>
              )
            })
            : (
              <tr>
                <td colSpan={8} className='text-danger text-center'>
                  No data found
                </td>
              </tr>
            )}
        </tbody>
      </Table>
    </div>
  )
}

export default PlayerReportTable
